import styled from "styled-components";
import bg from "../assets/images/background.jpeg";

export const NavWrapper = styled.nav`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
`;

export const NavLinksWrapper = styled.div`
  flex: 1;
  display: flex;
`;

export const PageWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  /* padding: 3rem 0; */
  box-sizing: border-box;

  @media (max-width: 48rem) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
  min-height: 100vh;

  @media (max-width: 48rem) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: auto;
    background-image: url(${bg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const HeaderWrapper = styled.div`
  padding: 3vw 4vw;
  @media (max-width: 48rem) {
    padding: 2.5rem 3rem 0;
    position: relative;
    display: flex;
    width: 100%;
    justify-content: center;
    box-sizing: border-box;
  }
`;

export const RightSide = styled.div`
  width: 45%;
  min-width: 30rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 1.5rem;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.primaryText};
  text-align: center;

  @media (max-width: 48rem) {
    position: static;
    width: 100%;
    padding: 2.5rem 1.5rem;
  }
`;

export const SocialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  position: absolute;
  bottom: 3vw;
  right: 6.5vw;
  transform: rotate(10deg);

  @media (max-width: 48rem) {
    transform: none;
    bottom: auto;
    position: static;
    margin-top: 1.5rem;
  }
`;

export const SocialLinksWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
`;

export const MessagesWrapper = styled.div`
  margin-left: 10rem;
  margin-top: -1rem;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;

  @media (max-width: 48rem) {
    position: static;
    margin-left: 0;
    margin-top: 0;
  }
`;

export const LinkMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;
